import React from "react";
import {
  Text,
  TextField,
  Group,
  TextInput,
  Checkbox,
  Button,
  Card,
} from "@mantine/core";
import { useForceUpdate } from "@mantine/hooks";
import RemoteSelect2 from "./remoteSelect2";
import FormReadOnlyField from "./formReadOnlyField";
import { FormSectionCard } from "../layout/page";
import { useTranslation } from "react-i18next";
import { isWidgetReadOnly } from "../helpers/formReadOnly";

const displayOrDash = (value) =>
  value === null || value === undefined || value === "" ? "-" : String(value);

const ProviderLoginInfoRow = ({
  item,
  form,
  name,
  readOnly = false,
  readonly = false,
  disabled = false,
}) => {
  const forceUpdate = useForceUpdate();
  const { t } = useTranslation();
  const locked = isWidgetReadOnly({ disabled, readOnly, readonly, form });

  return (
    <FormSectionCard>
      <Group grow>
        <RemoteSelect2
          apiEntity="provider"
          label={t("Provider")}
          value={item.content["provider"]}
          searchFields={["name", "code", "shortName"]}
          labelRender={(item) =>
            `[${item.code}] ${item.shortname ?? item.name}`
          }
          onDataChange={(data) => {
            if (locked) return;
            item.content["provider"] = data._id;
          }}
          pageSize={1000}
          sort={{ by: "name", order: "asc" }}
          disabled={locked}
          readOnly={locked}
          form={form}
        />
        {locked ? (
          <FormReadOnlyField
            label={t("Url Address")}
            value={displayOrDash(item.content["url"])}
          />
        ) : (
          <TextInput
            placeholder="http://www.aia.com.hk"
            label={t("Url Address")}
            value={item.content["url"]}
            miw={400}
            onChange={(e) => {
              item.content["url"] = e.target.value;
              forceUpdate();
            }}
          />
        )}
      </Group>
      <Group grow mt="md">
        {locked ? (
          <FormReadOnlyField
            label={t("Login Name / Email")}
            value={displayOrDash(item.content["username"])}
          />
        ) : (
          <TextInput
            placeholder={t("Username")}
            label={t("Login Name / Email")}
            value={item.content["username"]}
            onChange={(e) => {
              item.content["username"] = e.target.value;
              forceUpdate();
            }}
          />
        )}
        {locked ? (
          <FormReadOnlyField
            label={t("Password")}
            value={displayOrDash(item.content["password"])}
          />
        ) : (
          <TextInput
            placeholder={t("Password")}
            label={t("Password")}
            value={item.content["password"]}
            onChange={(e) => {
              item.content["password"] = e.target.value;
              forceUpdate();
            }}
          />
        )}
      </Group>
    </FormSectionCard>
  );
};

export default ProviderLoginInfoRow;
